import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { selectUser } from "../../components/auth/auth.selector";
import PageMappingForm from "../../components/feature-control/mapping/PageMappingForm";
import { fetchDashboardFeatureMappingData } from "../../redux/dashboard-features/featuresSlice";
import MappedPages from "../../components/feature-control/mapping/MappedPages";
import CmnFilters from "../../components/lead-management/common/CmnFilters";

const PageMap = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();
  const { dashboardFeaturesLoading } = useSelector((state) => state.features);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    // selectedGym: "",
    accountType: "",
    selAddedby: "",
    selectedFeatureGroup: "",
    // selectedMenu: "",
    // selectedFeature: "",
    // searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    account_type: allFilters.accountType?.value || "",
    user_id: allFilters.selAddedby?.value || "",
    feature_group_id: allFilters.selectedFeatureGroup?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  // const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  // const onClickSearch = () => {
  //   setIsPage(0);

  //   if (allFilters.searchString) {
  //     setSearchFilterApplied(true);
  //     setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
  //   }
  // };

  function getMappedFeatures(filters) {
    dispatch(
      fetchDashboardFeatureMappingData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getMappedFeatures(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      account_type: allFilters.accountType?.value || "",
      user_id: allFilters.selAddedby?.value || "",
      feature_group_id: allFilters.selectedFeatureGroup?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.accountType,
    allFilters.selAddedby,
    allFilters.selectedFeatureGroup,
  ]);

  // useEffect(() => {
  //   if (allFilters.searchString?.length === 0) {
  //     setSearchFilterApplied(false);
  //     setFilters((prevs) => ({ ...prevs, search: "" }));
  //     setIsPage(0);
  //   }
  // }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Feature Mapping">
      <Container className="bg-cloud-k px-50px" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <PageMappingForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getMappedFeatures(filters)}
            />
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Feature Group/Feature Mapping"}
              createBtnTxt={"+ Map New Feature Group/Feature"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getMappedFeatures(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"feature-mappings"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              // onClickSearch={onClickSearch}
              // searchFilterApplied={searchFilterApplied}
              isLoading={dashboardFeaturesLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <MappedPages
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getMappedFeatures(filters)}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PageMap;
